// design
import { iconApplication } from "@/design/icon/iconConst";

// model
import {
  modules,
  routes as routeName,
  names as moduleName,
  titles as moduleTitle,
  routes as moduleRoute,
  pageTitles as modulePageTitle
} from "@/model/employeeAccess/modules";

// utils
import {
  getLocalStorageItem,
  setLocalStorageItem
} from "@/utils/localStorageUtility";

/**
 * Get Module by module name
 * @param {String} name
 * @returns {{title: String, icon: String, name: String, route: String, entity: String}}
 */
const getModule = name => modules.find(el => el.name === name);

/**
 * Get icon name
 * @param {String} moduleName
 * returns icon name
 * @returns {String}
 */
const getIcon = moduleName => {
  const module = modules.find(el => el.name === moduleName);
  return module ? module.icon : iconApplication;
};

/**
 * Local Storage Keys
 * @type {Readonly<{moduleName: string}>}
 */
const localStorageKey = Object.freeze({
  moduleName: "employeeAccessModule"
});

/**
 * Store Module Name to the local Storage
 * @param {String} name:
 */
const storeModuleName = name =>
  setLocalStorageItem(localStorageKey.moduleName, name);

/**
 * Get Stored Module Name from local Storage
 * @returns {String|string}
 */
const getStoredModuleName = () =>
  getLocalStorageItem(localStorageKey.moduleName);

export {
  modules,
  moduleRoute,
  moduleTitle,
  modulePageTitle,
  moduleName,
  routeName,
  getIcon,
  getModule,
  storeModuleName,
  getStoredModuleName
};
